import { render, staticRenderFns } from "./sub_workspaces.vue?vue&type=template&id=8b510e22&scoped=true"
import script from "./sub_workspace?vue&type=script&lang=js&external"
export * from "./sub_workspace?vue&type=script&lang=js&external"
import style0 from "./sub_workspaces.vue?vue&type=style&index=0&id=8b510e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b510e22",
  null
  
)

export default component.exports